import { ColoursObj } from '@eventr/common-storybook'
import { Box, Divider, Stack } from '@mui/material'
import { motion } from 'framer-motion'
import { useChatBodyContext } from '../chatProvider'

interface ActionSheetItemProps {
    icon: React.ReactNode
    label: React.ReactNode | string
    download?: any
    onClick?: () => void
}
export const ActionSheetItem = ({
    icon,
    label,
    download,
    onClick,
}: ActionSheetItemProps) => {
    const { api, getDownloadUrl } = useChatBodyContext()
    return (
        <motion.div
            whileTap={{
                backgroundColor: ColoursObj.shades.shade3,
            }}
        >
            {download ? (
                <a
                    href={getDownloadUrl(
                        api.value.chatApi.host + download.title_link
                    )}
                    style={{ textDecoration: 'none' }}
                >
                    <Stack
                        alignItems={'center'}
                        width={'100%'}
                        height={'40px'}
                        onClick={onClick}
                        direction={'row'}
                    >
                        <Box marginLeft={'16px'} marginRight={'16px'}>
                            {icon}
                        </Box>
                        {label}
                    </Stack>
                </a>
            ) : (
                <Stack
                    alignItems={'center'}
                    width={'100%'}
                    height={'40px'}
                    onClick={onClick}
                    direction={'row'}
                >
                    <Box marginLeft={'16px'} marginRight={'16px'}>
                        {icon}
                    </Box>
                    {label}
                </Stack>
            )}

            <Divider />
        </motion.div>
    )
}
